/**
 * TtfLocaTable.ts class for EJ2-PDF
 */
var TtfLocaTable = /** @class */ (function () {
    function TtfLocaTable() {
    }
    return TtfLocaTable;
}());
export { TtfLocaTable };
